<template>
  <DialogWrapper
    close-on-cancel
    class="invite-agree-consent-dialog"
    :cancelBtnLabelI18nKey="cancelBtnLabelI18nKey"
    :saveBtnLabelI18nKey="saveBtnLabelI18nKey"
    :show.sync="show"
    :loading="loading"
    :titleI18nKey="`${i18nPrefix}.title.inviteConsentTitle`"
    @save="handleSave"
  >
  <div class="invite-content">
    <div v-if="consentDialogInfo.type === 'link'" class="link-content">
      <div class="link-title">{{ $t(`${i18nPrefix}.label.consentLinkTitle`) }}</div>
      <div class="link-label">{{ $t(`${i18nPrefix}.label.consentLinkLabel`) }}</div>
      <el-input v-model="consentDialogInfo.link" type="textarea" rows="2" disabled></el-input>
    </div>
    <div v-else-if="consentDialogInfo.type === 'qrCode'" class="qr-code-content">
      <div class="title">
        <div class="qr-code-title">{{ $t(`${i18nPrefix}.label.consentQrCodeTile`) }}</div>
        <div class="qr-code-label">{{ $t(`${i18nPrefix}.label.consentQrCodeLabel`) }}</div>
      </div>
      <div class="qr-code-body">
        <img class="qr-code-img" :src="consentDialogInfo.qrCodeUrl"/>
      </div>
    </div>
    <div v-else-if="consentDialogInfo.type === 'send'" class="send-email-content">
      <div class="send-email-title">{{ $t(`${i18nPrefix}.label.consentSendTitle`) }}</div>
    </div>
  </div>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
export default {
  components: {
    DialogWrapper
  },
  props: {
    consentDialogInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      show: false,
      loading: false
    }
  },
  computed: {
    cancelBtnLabelI18nKey () {
      if (this.consentDialogInfo.type === 'send') {
        return 'common.btn.noInvite'
      } else {
        return 'common.btn.cancel'
      }
    },
    saveBtnLabelI18nKey () {
      if (this.consentDialogInfo.type === 'link') {
        return 'common.btn.copy'
      } else if (this.consentDialogInfo.type === 'qrCode') {
        return 'common.btn.download'
      } else {
        return 'common.btn.yesInvite'
      }
    }
  },
  created () {

  },
  methods: {
    openDialog () {
      this.show = true
    },
    async handleSave () {
      this.$emit('handleSave')
      this.show = false
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.invite-agree-consent-dialog {
  .invite-content {
    .link-content {
      .link-title {
        margin-bottom: 20px;
        word-break: break-word;
        white-space: normal;
      }

      .link-label {
        margin-bottom: 10px;
      }
    }

    .qr-code-content {
      .title {
        .qr-code-title {
          margin-bottom: 20px;
          word-break: break-word;
          white-space: normal;
        }

        .qr-code-label {
          margin-bottom: 10px;
        }
      }

      .qr-code-body {
        text-align: center;
        .qr-code-img {
          width: 200px;
        }
      }
    }

    .send-email-content {
      margin-bottom: 50px;
      .send-email-title {
        word-break: break-word;
        white-space: normal;
      }
    }
  }
}
</style>
